import { format } from 'owa-strings';
import { getOwaMiniStrings, OwaMiniStrings } from 'owa-strings/owa-mini-strings';
/**
 * Returns aria label when a folder is focused in a folder pane
 * @param folderName folder name
 * @param count number of unread/total messages in the folder
 * @param isMoveToFolderPane is move to folder pane shown
 * @param isSelectedFolder is the folder a selected folder
 * @param isTotalCount is the count passed as a parameter, total count of messages in the folder
 */
export default function getFolderItemAriaLabel(
    folderName: string,
    count: number,
    isMoveToFolderPane: boolean,
    isSelectedFolder: boolean,
    isTotalCount?: boolean
): string {
    const strings: OwaMiniStrings = getOwaMiniStrings();
    let folderDetails: string = folderName;
    if (!isMoveToFolderPane && count) {
        if (isTotalCount) {
            folderDetails =
                count > 1
                    ? format(strings.folderWithMultipleMessagesAriaLabel, folderName, count)
                    : format(strings.folderWithSingleMessageAriaLabel, folderName);
        } else {
            folderDetails =
                count > 1
                    ? format(strings.folderWithMultipleUnreadMessagesAriaLabel, folderName, count)
                    : format(strings.folderWithSingleUnreadMessageAriaLabel, folderName);
        }
    }

    const ariaLabel = isSelectedFolder
        ? format(strings.folderWithSelectionAriaLabel, folderDetails)
        : folderDetails;
    return ariaLabel;
}
